import { tApi } from 'tplus-api';

export default class Api {

  static async webapiProxyReq(...args) {
    const resp = await tApi(...args);
    // let json = resp.data;
    // if(typeof(json) == 'string'){
    //   json = JSON.parse(resp.data.Value);
    // }
    return resp;
  }

  /**
   * 获取客户分类
   * @param {Bool} IsEnd 是否只获取最末级分类（新增客户时只获取最末级）
   */
  static async GetPartnerClass(IsEnd) {
    const {PartnerClass} = await this.webapiProxyReq({
      IsEnd
     }, 'chanjet.AA.MB.MBAACustomer.GetPartnerClass', false);
    return PartnerClass;
  }

  /**
   * 获取存货分类
   * 
   */
  static async GetInventoryClass() {
    const {InventoryClass} = await this.webapiProxyReq({}, 'chanjet.AA.MB.MBAAInventory.GetInventoryClass', false);
    return InventoryClass;
  }

}